module.exports = __webpack_public_path__ + "img/face-grin-wink.fcc6f64a.svg";